import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppValuationRequestNewCondition = (): DescribeNodeType =>
  'een nieuwe waardebepaling is aangevraagd';

export default describeAppValuationRequestNewCondition;
